import React from 'react'
import { Box, Grid, Skeleton } from '@mui/material'

const SkeletonBox: React.FC<any> = (props) => {
  return (
    <Skeleton
      {...props}
      sx={{
        borderRadius: '0.25rem',
        ...props.sx, // allow overriding or adding styles
      }}
    />
  )
}

export const CardSkeleton = ({ count }: { count: number }) => {
  return (
    <Box width="100%" data-testid="ta-card-skeleton">
      {[...Array(count)].map((_, index) => (
        <Grid item xs={12} md={12} lg={9} key={index}>
          <SkeletonBox
            variant="rectangular"
            height={225}
            sx={{ mb: '1.5rem' }}
          />
        </Grid>
      ))}
    </Box>
  )
}

export const TextAnalysisSkeleton = () => {
  return (
    <Box>
      {/* Header skeleton */}
      <Box sx={{ height: '10rem' }}>
        <Box
          sx={{
            height: '4rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
        >
          <SkeletonBox variant="rectangular" width={140} height={36} />
        </Box>

        <Box>
          <SkeletonBox variant="rectangular" width={140} height={36} />
        </Box>
      </Box>

      {/* Tabs skeleton */}
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          borderBottom: 1,
          borderColor: 'divider',
          paddingBottom: '0.5rem',
        }}
      >
        {Array.from({ length: 3 }).map((_, idx) => (
          <SkeletonBox
            key={idx}
            variant="rectangular"
            width={100}
            height={40}
          />
        ))}
      </Box>

      {/* Filter skeleton */}
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          pt: 1.75,
        }}
      >
        {Array.from({ length: 4 }).map((_, idx) => (
          <SkeletonBox
            key={idx}
            variant="rectangular"
            width={150}
            height={50}
          />
        ))}
      </Box>

      {/* Content skeleton */}
      <Grid container sx={{ pt: 1.75, gap: 2 }}>
        <Grid item xs={12}>
          <SkeletonBox variant="rectangular" height={55} />
        </Grid>
        <Grid item xs={9}>
          <SkeletonBox variant="rectangular" height={225} />
        </Grid>
        <Grid item xs={9}>
          <SkeletonBox variant="rectangular" height={225} />
        </Grid>
      </Grid>
    </Box>
  )
}
